import React, { Component } from "react";
import { Link } from "react-router";
import { t } from 'c-3po';
import * as Urls from "platopulse/lib/urls";

export default class NotFound extends Component {
    render() {
        return (
            <div className="layout-centered flex full">
                <div className="p4 text-bold">
                    <h1 className="text-brand text-light mb3">{t`We're a little lost...`}</h1>
                    <p className="h4 mb1">{t`The page you asked for couldn't be found`}.</p>
                    <p className="h4"></p>
                    <p className="h4 my4">{t`You can always:`}</p>
                    <div className="flex align-center">
                        <Link to={Urls.question()} className="Button Button--primary">
                            <div className="p1">{t`Ask a new question.`}</div>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/NotFound.jsx